export class OrderByModel{
    sortType:string;
    orderByAttribute:string;

    private constructor(sortType: string, orderByAttribute: string) {
        this.sortType = sortType;
        this.orderByAttribute = orderByAttribute;
    }

    public static desc(orderByAttribute:string){
        return new OrderByModel("DESC", orderByAttribute);
    }
    public static asc(orderByAttribute:string){
        return new OrderByModel("ASC", orderByAttribute);
    }
}
